import { Box, List, Typography, useTheme } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

import { useNav } from '../../../hooks/useNav';
import { NavItemType } from '../../../types/types';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

interface NavGroupProps {
  item: NavItemType;
  selectedItems: string | undefined;
  selectedLevel: number;
  setSelectedItems: Dispatch<SetStateAction<string | undefined>>;
  setSelectedLevel: Dispatch<SetStateAction<number>>;
}

const NavGroup = ({
  item,
  selectedItems,
  selectedLevel,
  setSelectedItems,
  setSelectedLevel,
}: NavGroupProps) => {
  const { drawerOpen } = useNav();
  const theme = useTheme();

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <NavCollapse
            key={menuItem.id || `collapse-${Math.random()}`}
            menu={menuItem}
            level={1}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
          />
        );
      case 'item':
        return (
          <NavItem
            key={menuItem.id || `item-${Math.random()}`}
            item={menuItem}
            level={1}
          />
        );
      default:
        return (
          <Typography
            key={menuItem.id || `error-${Math.random()}`}
            variant="h6"
            color="error"
            align="center"
          >
            Menu Item Error
          </Typography>
        );
    }
  });

  const isVisible =
    typeof item.isVisible === 'function'
      ? item.isVisible({})
      : item.isVisible !== false;

  return isVisible ? (
    <>
      <List
        subheader={
          drawerOpen &&
          item.title && (
            <Box sx={{ px: 2, mb: 1.5, mt: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: theme.sidebar.group.label,
                  fontSize: '0.6875rem',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                }}
              >
                {item.title}
              </Typography>
            </Box>
          )
        }
        sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
      >
        {navCollapse}
      </List>

      {/* {drawerOpen && (
        <Divider
          sx={{
            mt: 0.25,
            mb: 1.25,
            borderColor: 'rgba(255,255,255,0.1)',
          }}
        />
      )} */}
    </>
  ) : null;
};

export default NavGroup;
